import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { IStrapiDocument, UpdateDetails } from 'src/app/interfaces/strapi';

import { PageComponent } from 'src/app/shared/components/page/page.component';
import { Meta, Title } from '@angular/platform-browser';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Regexes } from 'src/app/shared/regexes';
import { UserService } from 'src/app/services/user.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { UniLookupComponent } from 'src/app/shared/components/uni-lookup/uni-lookup.component';
import { UniListComponent } from 'src/app/shared/components/uni-list/uni-list.component';
import { UniAddComponent } from 'src/app/shared/components/uni-add/uni-add.component';
import { University } from 'src/app/shared/models/university.model';
import { ResidenceLookupComponent } from 'src/app/shared/components/residence-lookup/residence-lookup.component';
import { ResidenceListComponent } from 'src/app/shared/components/residence-list/residence-list.component';
import { ResidenceAddComponent } from 'src/app/shared/components/residence-add/residence-add.component';
import { Residence } from 'src/app/shared/models/residence.model';
import { ResidenceService } from 'src/app/services/residence.service';
import { ApiError, ApiSearchResponse } from 'src/app/interfaces/api';
import { User } from 'src/app/shared/models/user.model';
import { Router } from '@angular/router';
import { UniService } from 'src/app/services/uni.service';
import StrapiService from 'src/app/services/strapi.service';
import { lastValueFrom } from 'rxjs';
import { NgIf } from '@angular/common';
import { PostcodeService } from '../../../services/postcode.service';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { AuthService } from '../../../services/auth.service';
import { ModalComponent as ModalComponent_1 } from '../../../shared/components/modal/modal.component';
import { ConfirmYourCoverComponent } from '../confirm-your-cover/confirm-your-cover.component';
import { TooltipComponent } from '../../../shared/components/tooltip/tooltip.component';
import { UniLookupComponent as UniLookupComponent_1 } from '../../../shared/components/uni-lookup/uni-lookup.component';
import { UniListComponent as UniListComponent_1 } from '../../../shared/components/uni-list/uni-list.component';
import { UniAddComponent as UniAddComponent_1 } from '../../../shared/components/uni-add/uni-add.component';
import { ResidenceLookupComponent as ResidenceLookupComponent_1 } from '../../../shared/components/residence-lookup/residence-lookup.component';
import { ResidenceListComponent as ResidenceListComponent_1 } from '../../../shared/components/residence-list/residence-list.component';
import { ErrorBlockComponent } from '../../../shared/components/error-block/error-block.component';
import { SuccessBlockComponent } from '../../../shared/components/success-block/success-block.component';
import { UserUpdateChoiceComponent } from '../../../shared/components/user-update-choice-modal/user-update-choice-modal.component';
import { UpdateUniAccommodationUnihomesComponent } from '../update-uni-accommodation-unihomes/update-uni-accommodation-unihomes.component';
import { TooltipModalComponent } from '../../../shared/components/tooltip-modal/tooltip-modal.component';

@Component({
    selector: 'app-update',
    templateUrl: './update.component.html',
    styleUrls: ['./update.component.scss'],
    imports: [
        BreadcrumbsComponent,
        NgIf,
        ModalComponent_1,
        ConfirmYourCoverComponent,
        FormsModule,
        ReactiveFormsModule,
        TooltipComponent,
        UniLookupComponent_1,
        UniListComponent_1,
        UniAddComponent_1,
        ResidenceLookupComponent_1,
        ResidenceListComponent_1,
        ErrorBlockComponent,
        SuccessBlockComponent,
        UserUpdateChoiceComponent,
        UpdateUniAccommodationUnihomesComponent,
        TooltipModalComponent,
    ],
})
export class UpdateComponent extends PageComponent implements OnInit {
  public override pageData: UpdateDetails = <UpdateDetails>{};

  public userForm!: UntypedFormGroup;

  public userSubmitted = signal(false);

  public userError = signal(false);

  public userSuccess = signal(false);

  // uni lookup modal stuff
  @ViewChild('uniLookupModal') public readonly uniLookupModal!: ModalComponent;

  public showUniLookupModal = signal(false);

  @ViewChild('uniLookup') public readonly uniLookup!: UniLookupComponent;

  public uniLookupSearchTerm = signal('');

  // uni list modal stuff
  @ViewChild('uniListModal') public readonly uniListModal!: ModalComponent;

  public showUniListModal = signal(false);

  @ViewChild('uniList') public readonly uniList!: UniListComponent;

  // uni add modal stuff
  @ViewChild('uniAddModal') public readonly uniAddModal!: ModalComponent;

  public showUniAddModal = signal(false);

  @ViewChild('uniAdd') public readonly uniAdd!: UniAddComponent;

  public addUniPrefill = signal('');

  @ViewChild('residenceLookupModal')
  public readonly residenceLookupModal!: ModalComponent;

  public showResidenceLookupModal = signal(false);

  @ViewChild('residenceLookup')
  public readonly residenceLookup!: ResidenceLookupComponent;

  public residenceLookupSearchTerm = signal('');

  // residence list modal stuff
  @ViewChild('residenceListModal')
  public readonly residenceListModal!: ModalComponent;

  public showResidenceListModal = signal(false);

  @ViewChild('residenceList')
  public readonly residenceList!: ResidenceListComponent;

  // residence add modal stuff
  @ViewChild('residenceAddModal')
  public readonly residenceAddModal!: ModalComponent;

  @ViewChild('residenceAdd')
  public readonly residenceAdd!: ResidenceAddComponent;

  public addResidencePrefill = signal('');

  public passwordForm!: UntypedFormGroup;

  public passwordSubmitted = signal(false);

  public passwordSuccess = signal(false);

  public passwordError = signal(false);

  public passwordErrorMessage = signal('');

  public showConfirm = signal(false);

  public changeType = signal<'user' | 'password' | ''>('');

  private selectedUniversity!: University;

  private selectedResidence!: Residence;

  public doingChanges = signal(false);

  public shouldShowCYC = signal(false);

  public showTooltipModal = signal(false);

  public tooltipModalContent = signal('');

  public accommodationStayingText = signal<string | null>('');

  public isPathwayProvider = signal(false);

  public isUnihome = signal(false);

  private passedPostcodeValidation: boolean = false;

  public showUserUpdateChoice = signal(false);

  public showUpdateUserFromUnihomes = signal(false);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,
    public override readonly strapi: StrapiService,
    public readonly authService: AuthService,
    private readonly user: UserService,
    private readonly residenceService: ResidenceService,
    private readonly uniService: UniService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: Router,
    private readonly postcodeService: PostcodeService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    if (this.authService.currentUser) {
      this.selectedUniversity = this.authService.currentUser.university;
      this.selectedResidence = this.authService.currentUser.accommodation;

      if (this.authService.currentUser.university.is_unihome_product) {
        this.isUnihome.set(true);
      }
    }

    this.initializeForms();

    this.strapi
      .getUpdateDetails()
      .subscribe((data: IStrapiDocument<UpdateDetails>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
      });
  }

  /**
   * Initialize forms on page
   *
   * @returns void
   */
  public initializeForms(): void {
    const uniId = this.authService.currentUser?.university.uuid ?? '';
    const uniName = this.authService.currentUser?.university.name ?? '';
    const accommodationId =
      this.authService.currentUser?.accommodation.uuid ?? '';
    const accommodationName =
      this.authService.currentUser?.accommodation.name ?? '';
    const postcode =
      this.authService.currentUser?.postcode?.toUpperCase() ?? '';

    this.userForm = this.formBuilder.group({
      university_id: [uniId, { validators: [Validators.required.bind(this)] }],
      university_name: [uniName],
      residence_id: [
        accommodationId,
        { validators: [Validators.required.bind(this)] },
      ],
      residence_name: [accommodationName],
    });

    this.uniLookupSearchTerm.set(
      String(this.authService.currentUser?.university.name)
    );
    this.residenceLookupSearchTerm.set(
      String(this.authService.currentUser?.accommodation.name)
    );

    if (this.authService.currentUser?.university.is_unihome_product) {
      this.userForm.addControl(
        'postcode',
        new UntypedFormControl(postcode, {
          validators: [
            Validators.pattern(Regexes.postcodeRegex),
            Validators.required.bind(this),
          ],
          updateOn: 'blur',
        })
      );

      this.userForm.get('postcode')!.valueChanges.subscribe(() => {
        this.userForm
          .get('postcode')
          ?.patchValue(this.userForm.get('postcode')!.value.toUpperCase(), {
            emitEvent: false,
          });
      });
    }

    if (this.authService.currentUser?.registrationMethod === 'EMAIL') {
      this.userForm.addControl(
        'email',
        new UntypedFormControl(this.authService.currentUser?.email, {
          validators: [
            Validators.email.bind(this),
            Validators.required.bind(this),
            Validators.pattern(Regexes.emailRegex),
          ],
          updateOn: 'blur',
        })
      );

      this.passwordForm = this.formBuilder.group({
        old_password: [
          '',
          { validators: [Validators.required.bind(this)], updateOn: 'blur' },
        ],
        new_password: [
          '',
          {
            validators: [
              Validators.required.bind(this),
              Validators.pattern(Regexes.passwordRegex),
            ],
            updateOn: 'blur',
          },
        ],
        confirm_new_password: [
          '',
          {
            validators: [
              Validators.required.bind(this),
              this.confirmAreEqual.bind(this),
            ],
            updateOn: 'blur',
          },
        ],
      });
    }
  }

  /**
   * Handle when user is not in university
   *
   * @returns void
   */
  public handleNotAtUni(): void {
    this.uniService.getImNotAtUniversityObject().subscribe({
      next: (university) => {
        const theUniResponse = <ApiSearchResponse>university;
        const uni = <University>theUniResponse.data;
        this.userForm.get('university_id')!.setValue(uni.uuid);
        this.userForm.get('university_name')!.setValue(uni.name);
        this.selectedUniversity = uni;
        this.accommodationStayingText.set(this.pageData.staying);
        this.hideUniSelectionModals();
        this.setAccommodationFieldText(uni);
      },
    });
  }

  protected override parsePageData(page: UpdateDetails): void {
    super.parsePageData(page);
    this.pageData = page;

    if (this.authService.currentUser) {
      this.setAccommodationFieldText(this.authService.currentUser?.university);
    }
  }

  public get userControl(): {
    [key: string]: AbstractControl;
  } {
    return this.userForm.controls;
  }

  public get passwordControl(): {
    [key: string]: AbstractControl;
  } {
    return this.passwordForm.controls;
  }

  /**
   * Show the confirm changes modal for user details update
   * @param e
   * @returns void
   */
  public submitUserForm(e: Event): void {
    e.preventDefault();
    this.userSubmitted.set(true);
    this.changeType.set('user');
    if (this.userForm.valid) {
      this.showConfirm.set(true);
    }
  }

  /**
   * Show the confirm modal for password changes
   * @param e
   * @returns void
   */
  public submitPasswordForm(e: Event): void {
    e.preventDefault();
    this.passwordSubmitted.set(true);
    this.changeType.set('password');
    if (this.passwordForm.valid && this.passwordForm.touched) {
      this.showConfirm.set(true);
    }
  }

  /**
   * Check if passwords are equal
   * @param confirmField
   * @returns
   */
  private confirmAreEqual(
    confirmField: AbstractControl
  ): ValidationErrors | null {
    if (this.passwordForm) {
      if (confirmField.value === this.passwordForm.get('new_password')?.value)
        return null;
      return { NotEqual: true };
    }
    return null;
  }

  public async doConfirm(): Promise<void> {
    this.doingChanges.set(true);

    switch (this.changeType()) {
      case 'password':
        this.changePassword();
        break;
      default:
        await this.updateUser();
        break;
    }
  }

  /**
   * update the user details
   * @returns void
   */
  public async updateUser(): Promise<void> {
    const clone = User.fromJson(this.authService.currentUser!);
    clone.universityId = this.selectedUniversity.uuid;
    clone.accommodationId = this.selectedResidence.uuid;
    clone.postcode = this.userForm.get('postcode')?.value;

    if (
      this.userForm.get('email') &&
      this.authService.currentUser?.email !== this.userForm.get('email')!.value
    ) {
      clone.email = String(this.userForm.get('email')!.value);
    }

    // we only want to validate postcode if the user is a unihomes user
    if (
      this.userForm.get('postcode') &&
      this.authService.currentUser?.university.is_unihome_product
    ) {
      clone.postcode = String(this.userForm.get('postcode')!.value);
      //   validate the postcode
      await this.validateAndContinue(clone.postcode);

      if (!this.passedPostcodeValidation) {
        this.showConfirm.set(false);
        this.doingChanges.set(false);
        this.userSubmitted.set(false);
        return;
      }
    }

    this.user.updateUser(clone).subscribe({
      next: () => {
        if (
          this.authService.currentUser?.accommodation.covered &&
          !this.authService.currentUser?.university.is_unihome_product
        ) {
          this.shouldShowCYC.set(true);
        }
      },
      error: () => {
        this.userSuccess.set(false);
        this.userError.set(true);
      },
      complete: () => {
        this.showConfirm.set(false);
        this.doingChanges.set(false);
        this.userSuccess.set(true);
        this.userError.set(false);
        this.userSubmitted.set(false);
        this.showUpdateUserFromUnihomes.set(false);
      },
    });
  }

  /**
   * update the users password request
   * @returns void
   */
  public changePassword(): void {
    this.authService
      .changePassword(
        String(this.passwordForm.get('old_password')?.value),
        String(this.passwordForm.get('new_password')?.value)
      )
      .subscribe({
        next: () => {
          this.passwordSuccess.set(true);
          this.passwordError.set(false);
          this.passwordSubmitted.set(false);
        },
        error: (error: ApiError) => {
          this.passwordError.set(true);
          this.passwordErrorMessage.set(String(error.error?.message));
        },
        complete: () => {
          this.showConfirm.set(false);
          this.doingChanges.set(false);
        },
      });
  }

  public displayUniLookupModal(): void {
    if (this.isUnihome()) return;
    this.showUniLookupModal.set(true);
    this.uniLookup.giveFocus();
  }

  public displayUniListModal($event: Event): void {
    if (this.isUnihome()) return;

    $event.stopPropagation();
    $event.preventDefault();
    this.showUniListModal.set(true);
  }

  public universitySelected(university: University): void {
    this.hideUniSelectionModals();
    this.userForm.get('university_id')?.setValue(university.uuid);
    this.userForm.get('university_name')?.setValue(university.name);
    this.uniLookupSearchTerm.set(university.name);
    this.addUniPrefill.set(university.name);
    this.selectedUniversity = university;
    this.setAccommodationFieldText(university);
  }

  public universityEntered(university: University): void {
    this.userForm.get('university_id')?.setValue(university.uuid);
    this.userForm.get('university_name')?.setValue(university.name);
    this.uniLookupSearchTerm.set(university.name);
    this.showUniAddModal.set(false);
    this.selectedUniversity = university;
    this.accommodationStayingText.set(this.pageData.staying);
  }

  public hideUniSelectionModals(): void {
    this.showUniLookupModal.set(false);
    this.showUniListModal.set(false);
  }

  public changeShowAddUniModal(lookupTerm: string): void {
    this.hideUniSelectionModals();
    if (lookupTerm) {
      this.addUniPrefill.set(lookupTerm);
    }
    this.showUniAddModal.set(true);
  }

  public displayResidenceLookupModal(): void {
    this.showResidenceLookupModal.set(true);
    this.residenceLookup.giveFocus();
  }

  public displayResidenceListModal($event: Event): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.showResidenceListModal.set(true);
  }

  public residenceSelected(residence: Residence): void {
    this.hideResidenceSelectionModals();
    this.userForm.get('residence_id')!.setValue(residence.uuid);
    this.userForm.get('residence_name')!.setValue(residence.name);
    this.residenceLookupSearchTerm.set(residence.name);
    this.addResidencePrefill.set(residence.name);
    this.selectedResidence = residence;
  }

  public residenceEntered(residence: Residence): void {
    this.userForm.get('residence_id')?.setValue(residence.uuid);
    this.userForm.get('residence_name')?.setValue(residence.name);
    this.residenceLookupSearchTerm.set(residence.name);
    this.selectedResidence = residence;
  }

  public hideResidenceSelectionModals(): void {
    this.showResidenceLookupModal.set(false);
    this.showResidenceListModal.set(false);
  }

  public handleAlternateResidence(slug: string): void {
    this.residenceService.getResidenceBySlug(slug).subscribe({
      next: (residence) => {
        const theResidenceResponse = <ApiSearchResponse>residence;
        const res = <Residence>theResidenceResponse.data;
        this.userForm.get('residence_id')!.setValue(res.uuid);
        this.userForm.get('residence_name')!.setValue(res.name);
        this.selectedResidence = res;
        this.hideResidenceSelectionModals();
      },
    });
  }

  // if the user closed the modal reset everything

  public confirmModalClosed(): void {
    if (!this.showConfirm()) {
      if (this.changeType() === 'user') {
        this.userSubmitted.set(false);
        this.userForm.reset(this.userForm.value);
      }
      if (this.changeType() === 'password') {
        this.passwordSubmitted.set(false);
        this.passwordForm.reset(this.passwordForm.value);
      }
    }
  }

  public onCoverModalDisplayChange(showModal: boolean): void {
    this.shouldShowCYC.set(showModal);

    // user has closed the modal, redirect them back to my profile per END-492
    if (!this.shouldShowCYC()) {
      this.router.navigate(['/app/my-profile']).finally(() => false);
    }
  }

  public openTooltip(id: string) {
    this.showTooltipModal.set(true);

    type PageDataIndex = keyof typeof this.pageData;

    const currentRoute = id as PageDataIndex;
    this.tooltipModalContent.set(this.pageData[currentRoute] as string);
  }

  private setAccommodationFieldText(uni: University): void {
    this.isPathwayProvider.set(uni.is_pathway_provider);
    if (uni.is_pathway_provider) {
      this.accommodationStayingText.set(this.pageData.staying_pathway_provider);
      return;
    }
    this.accommodationStayingText.set(this.pageData.staying);
  }

  async validateAndContinue(postcode: string) {
    try {
      await lastValueFrom(this.postcodeService.validatePostcode(postcode));
      this.passedPostcodeValidation = true;
    } catch (error) {
      this.passedPostcodeValidation = false;
      this.userForm
        .get('postcode')
        ?.setErrors({ pattern: 'The entered postcode does not exist.' });
    }
  }

  /**
   * open model for the user to confirm they are no longer a customer
   */
  public noLongerAUniHomeCustomer(): void {
    this.showUserUpdateChoice.set(true);
  }

  handleNoLongerACustomerChoice($event: boolean) {
    if ($event) {
      this.showUpdateUserFromUnihomes.set(true);
      this.showUserUpdateChoice.set(false);
    } else {
      this.showUserUpdateChoice.set(false);
    }
  }

  getFormattedLink() {
    return this.pageData.no_longer_a_customer_link_name?.replaceAll(
      '<name>',
      this.authService.currentUser?.university.name ?? ''
    );
  }

  unihomeUpdateComplete($event: boolean) {
    this.showUpdateUserFromUnihomes.set(false);
    if (!$event) return;
    if (this.authService.currentUser?.accommodation.covered) {
      this.shouldShowCYC.set(true);
    } else {
      this.router.navigate(['/app/my-profile']).finally(() => false);
    }
  }
}
